import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { internalPage } from '../../Constant';
import './SelfCareHeader.scss';
import EpiContext from '@episerver/spa-core/Spa';

const WelcomeUserText = (props) => {
  const [customerName, setCustomerName] = useState('');
  const [isShowPencil, setIsShowPencil] = useState(false);
  const [isNoCustomerName, setIsNoCustomerName] = useState(false);
  let firstName = props?.authentication?.loginData?.userDetails?.firstName;

  useEffect(() => {
    if (props?.authentication?.loginData?.isFullAuthenticated || props?.authentication?.loginData?.isOtpExtendedAuthenticated) {
      setIsShowPencil(false);
      setIsNoCustomerName(false);
      setCustomerName(firstName);
    } else {
      if (firstName && firstName?.length > 1) {
        setCustomerName(firstName);
        isShowExtras(true);
      } else {
        isShowExtras(false);
        setCustomerName(props?.authentication?.loginData?.userDetails?.contactNumber);
      }
    }
  }, [props.isFetchLoginData, firstName]);

  const isShowExtras = (isFirstName) => {
    if (props.isFetchLoginData) {
      setIsShowPencil(true);
      if (!isFirstName) {
        setIsNoCustomerName(true);
      }
    } else {
      setIsShowPencil(false);
      setIsNoCustomerName(false);
    }

  }


  const pencil = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.43 9.537a.437.437 0 0 1-.31-.747l6.837-6.837a.437.437 0 1 1 .619.619L2.739 9.409a.436.436 0 0 1-.31.128z" fill="#000000" />
    <path d="M1.754 12.688a.44.44 0 0 1-.428-.53L2 9.008a.438.438 0 0 1 .856.183l-.676 3.15a.438.438 0 0 1-.427.347zM4.904 12.012a.437.437 0 0 1-.31-.747l6.837-6.837a.437.437 0 1 1 .62.619l-6.837 6.836a.436.436 0 0 1-.31.129z" fill="#000000" />
    <path d="M1.753 12.688a.438.438 0 0 1-.091-.866l3.15-.676a.438.438 0 0 1 .184.856l-3.15.676a.427.427 0 0 1-.093.01zM10.504 6.412a.435.435 0 0 1-.31-.128L7.72 3.81a.437.437 0 1 1 .62-.618l2.474 2.474a.437.437 0 0 1-.31.747zM11.74 5.175a.436.436 0 0 1-.309-.747c.243-.244.378-.573.378-.928 0-.355-.135-.685-.378-.928a1.301 1.301 0 0 0-.928-.378 1.3 1.3 0 0 0-.928.378.437.437 0 1 1-.619-.619 2.17 2.17 0 0 1 1.547-.634 2.17 2.17 0 0 1 1.547.634c.408.409.633.958.633 1.547a2.17 2.17 0 0 1-.633 1.547.435.435 0 0 1-.31.128z" fill="#000000" />
  </svg>


  return (
    <div className="welcome-user-text">
      <div className='welcome-user-container'>
        <div className='edit-name-container'> {customerName?.length > 0 ? <p>היי {customerName},</p> : <p>היי,</p>}
          {isShowPencil && <div className='pencil' onClick={() => EpiContext.navigateTo(props.updateSubscriberNameLink)}>{pencil}</div>}
        </div>
        <p>{props.subHeader}</p>
        {isNoCustomerName && <span onClick={() => EpiContext.navigateTo(props.updateSubscriberNameLink)} className='purple-msg'>{props.noNameText}</span>}
      </div>
    </div >
  );
}

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    selfCareSlice: state.selfcarePage,
    isFetchLoginData: state.selfcarePage.isFetchLoginData,
    updateSubscriberNameLink: state.selfcarePage.links?.updateSubscriberNameLink,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeUserText);
